export const ERR_NEED_SUBSCRIBE = 20002
export const ERR_NEED_DIAMOND = 20001
export const ERR_CHAT_LIMIT = 30004
export const ERR_ORDER_LIMIT = 20004